import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import Toast from 'components/Toast/Toast'

import Description from '../../components/Description/Description'
import TopBar from '../../components/TopBar/TopBar'

import { HIDDEN_ROLE_IDS } from './constants'

import styles from './ChooseRole.module.scss'

const ChooseRole = ({ currentStep, stepsCount, group, onBack, onSelect = () => {} }) => {
    const { t } = useTranslation()
    const [selectedRoleId, setSelectedRoleId] = useState(null)
    const [roles, setRoles] = useState([])

    useEffect(() => {
        setRoles(group.userRoleInProjectDtos.filter(role => !HIDDEN_ROLE_IDS.includes(role.id)))
    }, [group])

    const onAction = async role => {
        try {
            setSelectedRoleId(role.id)
            await new Promise(r => setTimeout(() => r(), 1000))

            await onSelect(role)
        } catch (err) {
            console.error(err)
            Toast('error', {})
        }
    }

    return (
        <div className={classNames(styles.roles, { [styles.isDisabledRoles]: !!selectedRoleId })}>
            <TopBar currentStep={currentStep} stepsCount={stepsCount} />
            <Description
                title={t('Choose your profile')}
                subTitle={t('Choose the role that suits you best.')}
                onBack={onBack}
            />
            <ul className={styles.list}>
                {roles.map(role => (
                    <li
                        className={classNames(styles.item, { [styles.isSelectedItem]: role.id === selectedRoleId })}
                        key={role.id}
                        onClick={() => onAction(role)}
                    >
                        <span className={styles.point}></span>
                        {role.roleTranslationDto.text}
                    </li>
                ))}
            </ul>
        </div>
    )
}

export default ChooseRole
